











import { computed, defineComponent } from '@vue/composition-api';
import qs from 'querystring';
export default defineComponent({
    props: {
        text: {
            type: String,
            default: '',
        },
        size: {
            type: [Number, String],
            default: 200,
        },
        qrSize: {
            type: Number,
            default: 100,
        },
    },
    setup(props) {
        const qrcodeUrl = computed(() => {
            if (props.text) {
                return `https://ksurl.cn/createqrcode?${qs.stringify({
                    content: props.text,
                    width: props.qrSize,
                    height: props.qrSize,
                    contentType: 'URL',
                    toShortUrl: false,
                })}`;
            }
            return '';
        });
        return {
            qrcodeUrl,
        };
    },
});
